/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsZero } from '../../factoriesAny.js';
export var isZeroDependencies = {
  typedDependencies,
  createIsZero
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsZero.generated.js
// module id = 2BK+
// module chunks = 3